import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from 'rxjs';
import { ApiError } from '../models/api-error.model';

export const errorInterceptor: HttpInterceptorFn = (req, next) =>
  next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const apiError: ApiError = {
        status: error.status,
        message: extractMessage(error),
      };
      return throwError(() => apiError);
    }),
  );

function extractMessage(error: HttpErrorResponse): string {
  if (error.status === 0) {
    return 'Could not reach the server. Check your connection and try again.';
  }
  if (error.status === 429) {
    return tooManyRequestsMessage(error);
  }
  if (error.status >= 500) {
    return 'Vehicle data is temporarily unavailable. Please try again.';
  }
  const title = (error.error as { title?: string } | null)?.title;
  return title ?? 'Something went wrong. Please try again.';
}

// Retry-After is unreadable cross-origin unless the server exposes it.
function tooManyRequestsMessage(error: HttpErrorResponse): string {
  const retryAfter = Number(error.headers.get('Retry-After'));

  if (!Number.isFinite(retryAfter) || retryAfter <= 0) {
    return 'Too many requests. Please slow down and try again shortly.';
  }

  const seconds = Math.ceil(retryAfter);
  return `Too many requests. Please wait ${seconds} second${seconds === 1 ? '' : 's'} and try again.`;
}
